export enum TipoSituacaoCadastral {
    SoftDelete = -1,
    Inativo = 0,
    Ativo = 1,
}

export enum TipoObjetivo {
  CheckList = 0,
  Anexo = 1,
  PedidoConfirmado = 2,
  NotaFiscal = 3
}

export enum FvTipoStatusOportunidade {
  Aberta = 0,
  Perdida = 1,
  Ganha = 2,
  Congelada = 3,
}

export enum FvTipoResposta {
  Perda = 1,
  Ganho = 2,
}

export enum TipoUsuario {
  Operador = 0,
  Integrador = 1,
}

export enum NtfTipoMensagem {
  Notificacao = 1,
  Conversa = 2,
}

export enum NtfPasta {
  Inbox = 1,
  Arquivo = 2,
  Lixeira = 3,
}

export enum NtfTipoConversa {
  Usuario = 1,
  Sistema = 2,
}

export enum NtfTipoVinculo {
  Orcamento = 1,
  Pedido = 2,
  SimulacaoFinanciamento = 3,
  CardPropostaFinanciamento = 4,
}

export enum NtfTipoCanal {
  Email = 1,
  Hub = 2,
}

export enum NtfTipoModeloEmail {
  Notificacao = 1,
}

export enum WfTipoExpressao {
  Evento = 0,
  Condicao = 1, Acao = 2,
  Parametro = 3,
  Funcao = 4,
  DTO = 5,
}

export enum WfOperadorGrupo {
  Algum = 0,
  Todos = 1,
}

export enum GiLojaTipoVinculo {
  Nenhum = 0,
  AnyCategoria = 1,
  AllCategoria = 2,
  AnyTabela = 3,
  AllTabela = 4,
}

export enum GiLojaTipoMenu {
  Home = 0,
  Navegacao = 1
}

export enum FvTipoFunil {
  Normal = 0,
  CarteiraIntegrador = 1,
  IntegradoresSemVendedor = 2,
  MonitorPropostaFinanciamento = 3,
  Orcamento = 4,
  Pedido = 5
}

export enum TipoOperadorFunil {
  Analista = 1,
  Auxiliar = 2,
  Gestor = 5,
}

export enum FinSimulacaoFinanciadoraStatus {
  Pendente = 0,
  Solicitando = 1,
  Disponivel = 2,
  Indisponivel = 3,

  // Novas
  Finalizado = 4,
  DadosSolicitacao = 5,
  ErroIntermitente = 20,
  ErroCritico = 29
}

